
<nz-skeleton [nzActive]="true" [nzLoading]="false">
    <nz-layout>

        <nz-content>
<form nz-form [formGroup]="RiskCreateForm" [nzLayout]="'vertical'" class="riskCreate__form">
    <div nz-row [nzGutter]="{ xs: 8, sm: 8, md: 8, lg: 24, xl: 48, xxl: 48 }">
        <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24">
            <nz-form-item >
                <nz-form-label nzFor="IrName" nzRequired>Feedback Subject
                    <span nz-tooltip nzTooltipTitle="Feedback Subject">
                        <i nz-icon class="icon-q" nzType="question-circle" nzTheme="outline"></i>
                    </span>
                </nz-form-label>
                <nz-form-control [nzErrorTip]="'Please enter Feedback Subject'">
                    <input nz-input placeholder="Feedback Subject" formControlName="name"
                        id="tnameype" />
                </nz-form-control>
            </nz-form-item>
        </div>
        <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24">
            <nz-form-item >
                <nz-form-label nzFor="IrNameOtherLang" nzRequired>Name in Other Language
                    <span nz-tooltip nzTooltipTitle="Name in Other Language">
                        <i nz-icon class="icon-q" nzType="question-circle" nzTheme="outline"></i>
                    </span>
                </nz-form-label>
                <nz-form-control [nzErrorTip]="'Please enter the IR Name'">
                    <input nz-input placeholder="Name in Other Language"
                        formControlName="nameInOtherLanguage" id="nameInOtherLanguagetype" />
                </nz-form-control>
            </nz-form-item>
        </div>
      
        <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24">
            <nz-form-item>
                <nz-form-label nzFor="infoSource" nzRequired>Source Of Information
                    <span nz-tooltip
                        nzTooltipTitle="Source Of Information">
                        <i nz-icon class="icon-q" nzType="question-circle" nzTheme="outline"></i>
                    </span>
                </nz-form-label>
                <nz-form-control [nzErrorTip]="'Please enter source of information'">
                    <nz-select id="infosourcetype" [nzPlaceHolder]="'Source Of Information'"
                        formControlName="infoSource" [nzShowSearch]="true">
                        <nz-option
                            *ngFor="let i of infoSourceList; let idx = index"
                            [nzLabel]="i.label" [nzValue]="i.label">
                        </nz-option>
                    </nz-select>
                </nz-form-control>
            </nz-form-item>
        </div>
        <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24"
            *ngIf="RiskCreateForm.controls.infoSource.value ==='Ministries'">
            <nz-form-item>
                <nz-form-label nzFor="ministryName">Name of the Ministry
                    <span nz-tooltip nzTooltipTitle="Name of the Ministry which provided this information">
                        <i nz-icon class="icon-q" nzType="question-circle" nzTheme="outline"></i>
                    </span>
                </nz-form-label>
                <nz-form-control [nzErrorTip]="'Please enter source of information'">
                    <nz-select id="minisrynametype" [nzPlaceHolder]="'Source of Information'"
                        formControlName="ministryName" [nzShowSearch]="true">
                        <nz-option
                            *ngFor="let i of  ministryNameList; let idx = index"
                            [nzLabel]="i.label" [nzValue]="i.label">
                        </nz-option>
                    </nz-select>
                </nz-form-control>
            </nz-form-item>
        </div>
        <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24"
            *ngIf="RiskCreateForm.controls.infoSource.value ==='Departments'">
            <nz-form-item>
                <nz-form-label nzFor="deptName">Name of the Department
                    <span nz-tooltip nzTooltipTitle="Name of the Department which provided this information">
                        <i nz-icon class="icon-q" nzType="question-circle" nzTheme="outline"></i>
                    </span>
                </nz-form-label>
                <nz-form-control [nzErrorTip]="'Please enter source of information'">
                    <nz-select id="departmentnametype" [nzPlaceHolder]="'Name of the Department'"
                        formControlName="departmentName" [nzShowSearch]="true">
                        <nz-option
                            *ngFor="let i of  departmentNameList;let idx = index"
                            [nzLabel]="i.label" [nzValue]="i.label">
                        </nz-option>
                    </nz-select>
                </nz-form-control>
            </nz-form-item>
        </div>
        <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24"
            *ngIf="RiskCreateForm.controls.infoSource.value ==='Anonymous Calls'">
            <nz-form-item>
                <nz-form-label nzFor="informerName">Name of Informer
                    <span nz-tooltip nzTooltipTitle="Name of Informer">
                        <i nz-icon class="icon-q" nzType="question-circle" nzTheme="outline"></i>
                    </span>
                </nz-form-label>
                <nz-form-control [nzErrorTip]="'Please enter Name of Informer.'">
                    <input nz-input placeholder="Name of Informer" formControlName="informerName"
                        id="informerNametype" />
                </nz-form-control>
            </nz-form-item>
        </div>
        <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24"
            *ngIf="RiskCreateForm.controls.infoSource.value ==='Anonymous Calls'">
            <nz-form-item>
                <nz-form-label nzFor="informerLocation">Location of Informer
                    <span nz-tooltip nzTooltipTitle="Location of Informer">
                        <i nz-icon class="icon-q" nzType="question-circle" nzTheme="outline"></i>
                    </span>
                </nz-form-label>
                <nz-form-control [nzErrorTip]="'Please enter Location of Informer.'">
                    <input nz-input placeholder="Location of Informer" formControlName="informerLocation"
                        id="informerLocationtype" />
                </nz-form-control>
            </nz-form-item>
        </div>
        <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24"
            *ngIf="RiskCreateForm.controls.infoSource.value ==='Anonymous Calls'">
            <nz-form-item>
                <nz-form-label nzFor="contactNum">Contact Number (If any)
                    <span nz-tooltip nzTooltipTitle="Phone Number of the Informer">
                        <i nz-icon class="icon-q" nzType="question-circle" nzTheme="outline"></i>
                    </span>
                </nz-form-label>
                <nz-form-control [nzErrorTip]="'Please enter Contact Number.'">
                    <input nz-input placeholder="Contact Number" formControlName="informerContactNumber"
                        (keypress)="numberOnly($event)" />
                </nz-form-control>
            </nz-form-item>
        </div>
        <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24" *ngIf="RiskCreateForm.controls.infoSource.value ==='Media'">
            <nz-form-item>
                <nz-form-label nzFor="mediaName">Name of Media
                    <span nz-tooltip nzTooltipTitle="Media information">
                        <i nz-icon class="icon-q" nzType="question-circle" nzTheme="outline"></i>
                    </span>
                </nz-form-label>
                <nz-form-control [nzErrorTip]="'Please enter Contact Number.'">
                    <input nz-input placeholder="Name of Media" formControlName="mediaName" id="mediaNametype" />
                </nz-form-control>
            </nz-form-item>
        </div>
        <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24" *ngIf="RiskCreateForm.controls.infoSource.value ==='Email'">
            <nz-form-item>
                <nz-form-label nzFor="emailId">Email ID
                    <span nz-tooltip nzTooltipTitle="The email Id from where email is received">
                        <i nz-icon class="icon-q" nzType="question-circle" nzTheme="outline"></i>
                    </span>
                </nz-form-label>
                <nz-form-control [nzErrorTip]="'Please enter Email ID.'">
                    <input nz-input placeholder="Email ID" formControlName="emailId" id="emailIdtype" />
                </nz-form-control>
            </nz-form-item>
        </div>
        <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24">
            <nz-form-item>
                <nz-form-label nzFor="riskArea">Risk Area
                    <span nz-tooltip nzTooltipTitle="Risk area, the information is  referring to">
                        <i nz-icon class="icon-q" nzType="question-circle" nzTheme="outline"></i>
                    </span>
                </nz-form-label>
                <nz-form-control [nzErrorTip]="'Please enter source of information'">
                    <nz-select id="riskareatype" [nzPlaceHolder]="'Risk Area'" formControlName="riskArea"
                        [nzShowSearch]="true">
                        <nz-option *ngFor="let i of  riskAreaTypeList; let idx = index"
                            [nzLabel]="i.label" [nzValue]="i.label">
                        </nz-option>
                    </nz-select>
                </nz-form-control>
            </nz-form-item>
        </div>
        <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24"
            *ngIf="RiskCreateForm.controls.infoSource.value ==='Others  (Please Specify)'">
            <nz-form-item>
                <nz-form-label nzFor="otherInfoSource">If Others, 'Please Specify'
                    <span nz-tooltip nzTooltipTitle="When source of information is others, user has to specify">
                        <i nz-icon class="icon-q" nzType="question-circle" nzTheme="outline"></i>
                    </span>
                </nz-form-label>
                <nz-form-control>
                    <input nz-input placeholder="If Others, 'Please Specify'" formControlName="otherInfoSource"
                        id="otherInfoSourcetype" />
                </nz-form-control>
            </nz-form-item>
        </div>
        
        <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24">
            <nz-form-item>
                <nz-form-label nzFor="priority">Priority
                    <span nz-tooltip nzTooltipTitle="Priority of considering this information">
                        <i nz-icon class="icon-q" nzType="question-circle" nzTheme="outline"></i>
                    </span>
                </nz-form-label>
                <nz-form-control>
                    <nz-select id="priorityType" [nzPlaceHolder]="'Priority'" formControlName="priority"
                        [nzShowSearch]="true">
                        <nz-option *ngFor="let i of priorityType; let idx = index"
                            [nzLabel]="i.label" [nzValue]="i.label">
                        </nz-option>
                    </nz-select>
                </nz-form-control>
            </nz-form-item>
        </div>
        <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24">
            <nz-form-item>
                <nz-form-label nzFor="severity">Severity
                    <span nz-tooltip nzTooltipTitle="Severity if this information">
                        <i nz-icon class="icon-q" nzType="question-circle" nzTheme="outline"></i>
                    </span>
                </nz-form-label>
                <nz-form-control>
                    <nz-select id="severitytype" [nzPlaceHolder]="'Severity'" formControlName="severity"
                        [nzShowSearch]="true">
                        <nz-option *ngFor="let i of severityType; let idx = index"
                            [nzLabel]="i.label" [nzValue]="i.label">
                        </nz-option>
                    </nz-select>
                </nz-form-control>
            </nz-form-item>
        </div>
        <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24">
            <nz-form-item>
                <nz-form-label nzFor="significance">Significance
                    <span nz-tooltip nzTooltipTitle="How significant and important this information is">
                        <i nz-icon class="icon-q" nzType="question-circle" nzTheme="outline"></i>
                    </span>
                </nz-form-label>
                <nz-form-control>
                    <nz-select id="significancetype" [nzPlaceHolder]="'Significance'" formControlName="significance"
                        [nzShowSearch]="true">
                        <nz-option
                            *ngFor="let i of significanceTypeList; let idx = index"
                            [nzLabel]="i.label" [nzValue]="i.label">
                        </nz-option>
                    </nz-select>
                </nz-form-control>
            </nz-form-item>
        </div>
    </div>
    <div nz-row [nzGutter]="{ xs: 8, sm: 8, md: 8, lg: 24, xl: 48, xxl: 48 }">
        <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24">
            <nz-form-item>
                <nz-form-label nzFor="infoDescription" nzRequired>Feedback Description
                    <span nz-tooltip nzTooltipTitle="Feedback Description">
                        <i nz-icon class="icon-q" nzType="question-circle" nzTheme="outline"></i>
                    </span>
                </nz-form-label>
                <nz-form-control [nzErrorTip]="errorTplinfoDescription">
                    <textarea rows="4" nz-input id="infoDescription" formControlName="infoDescription"></textarea>
                    <ng-template #errorTplinfoDescription let-control>
                        <ng-container *ngIf="control.hasError('required')">
                            Description is required
                        </ng-container>
                        <ng-container *ngIf="control.hasError('maxlength')">
                            Text should not be more than 200 characters
                        </ng-container>
                    </ng-template>
                    <small *ngIf="RiskCreateForm.controls.infoDescription.value" class="form-text text-muted">
                        <code>{{RiskCreateForm.controls.infoDescription.value.length}}</code> of
                        <code>{{RemarksMaxLength}}</code> characters</small>
                </nz-form-control>
            </nz-form-item>
        </div>
        <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24">
            <nz-form-item>
                <nz-form-label nzFor="submitterRemarks">Submitter Remarks
                    <span nz-tooltip nzTooltipTitle="Status of Information Request during the workflow">
                        <i nz-icon class="icon-q" nzType="question-circle" nzTheme="outline"></i>
                    </span>
                </nz-form-label>
                <nz-form-control>
                    <textarea rows="4" nz-input id="submitterRemarks" formControlName="submitterRemarks"></textarea>
                </nz-form-control>
                <small *ngIf="RiskCreateForm.controls.submitterRemarks.value" class="form-text text-muted">
                    <code>{{RiskCreateForm.controls.submitterRemarks.value.length}}</code> of
                    <code>{{RemarksMaxLength}}</code> characters</small>
            </nz-form-item>
        </div>
       
        <nz-divider></nz-divider>
        <br>
        <div nz-col [nzSpan]="24">
            <button id="close" nz-button nzType="default" class="mr-md mob-mr-md btnStyle text-right" (click)="close()" >
                <i nz-icon nzTheme="outline" nzType="close-circle"></i>Cancel</button>
            <button nz-button type="button" nzType="primary" id="submitRiskInfo" (click)="submitRiskInfo(true)"
                class="mr-md mob-mr-md btnStyle text-right"><i nz-icon nzType="plus-circle" nzTheme="outline"></i> {{buttonName}}</button>    
        </div>
    </div>
</form>
</nz-content>
</nz-layout>
</nz-skeleton>